export default "__VITE_ASSET__B21OTHGy__"